import { render, staticRenderFns } from "./ButtonRound.vue?vue&type=template&id=38a83066&scoped=true&"
import script from "./ButtonRound.vue?vue&type=script&lang=ts&"
export * from "./ButtonRound.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonRound.vue?vue&type=style&index=0&id=38a83066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a83066",
  null
  
)

export default component.exports